import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { seasonalWindow } from '@/core/components/sites/site/seasonal-cancellation-policies/seasonal.utils'
import { seasonalAssignmentsQueryOptions } from '@/core/components/sites/site/seasonal-cancellation-policies/seasonalCancellationPoliciesQueryOptions'
import { seasonalCatalogQueries } from '@/core/components/sites/site/seasonal-cancellation-policies/useSeasonalCatalog'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const seasonalPoliciesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/'
)({
  validateSearch: (search) => seasonalPoliciesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Blogger']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  // Everything the screen and the Add sheet read, in parallel, so opening the
  // sheet never suspends on the rate / activity / policy lists.
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const token = auth.token!
    const [rates, packages, activities, policies] = seasonalCatalogQueries(
      siteId,
      token
    )
    return Promise.all([
      queryClient.ensureQueryData(
        seasonalAssignmentsQueryOptions(siteId, seasonalWindow(), token)
      ),
      queryClient.ensureQueryData(rates),
      queryClient.ensureQueryData(packages),
      queryClient.ensureQueryData(activities),
      queryClient.ensureQueryData(policies),
    ])
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
